module.exports = __webpack_public_path__ + "assets/Retina-LightItalic.4e7b7018af947c914027cd4c0181a86c.woff";